import getCdnUrl from '../helpers/get-cdn-url';

const BCIImage = getCdnUrl('/logos/logobci.avif');

export default BCIImage;
